var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 10,
    viewBox: "0 0 20 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6129 0.209705L15.7071 0.292893L19.7071 4.29289C20.0676 4.65338 20.0953 5.22061 19.7903 5.6129L19.7071 5.70711L15.7071 9.70711C15.3166 10.0976 14.6834 10.0976 14.2929 9.70711C13.9324 9.34662 13.9047 8.77939 14.2097 8.3871L14.2929 8.29289L16.585 6H1C0.447715 6 0 5.55228 0 5C0 4.44772 0.447715 4 1 4H16.585L14.2929 1.70711C13.9324 1.34662 13.9047 0.779392 14.2097 0.387101L14.2929 0.292893C14.6534 -0.0675907 15.2206 -0.0953203 15.6129 0.209705Z",
    fill: "#FF5C6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkArrow);
export default __webpack_public_path__ + "static/media/LinkArrow.a56f2504c2e7960a8c35f16bb80a2ef4.svg";
export { ForwardRef as ReactComponent };